import qs from 'qs'

export const queryPermanentWorksPageThumbnail = () => {
  const query = qs.stringify(
    {
      populate: {
        ...queryFragmentSingleTypeDefault,
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `permanent-works-page?${query}`
}
